import { render, staticRenderFns } from "./serviceMenu.vue?vue&type=template&id=22219d1a"
import script from "./serviceMenu.vue?vue&type=script&lang=js"
export * from "./serviceMenu.vue?vue&type=script&lang=js"
import style0 from "./serviceMenu.vue?vue&type=style&index=0&id=22219d1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports